import React, { Component } from 'react'
import { Redirect, Link } from 'react-router-dom'
import M from 'materialize-css'
import { HomeIcon } from '@heroicons/react/outline'
import Modal from '../UI/Modal'
import Loader from '../UI/Loader'
import StripePayments from './StripePayments'
import tools from '../../tools'

class ConfigAdmin extends Component {
	constructor(props) {
		super(props)
		this.state = {
			tab: 'config',
			attempt_submit: false,
			form1: {
				active_connexion: false,
				show_stay_dates: false,
				show_stay_location: false,
				application_ouverte: false,
				bcc_inventories: "",
				bcc_services: "",
				default: "",
				inventories: "",
				services: "",
				due_billing_unpaid: 0,
				due_billing_date: "",
				due_billing_url: ""
			},
			features: this.props.features,
			config_pms: null,
			modal_msg: null,
			open_modal: false,
			error: this._initErrors(),
			success: null,
			current_lang: this.props.lang_default
		}
		this.length_max = 40
		this.props.updateNavbarTitle('Paramètres administrateurs')
	}

	componentDidMount() {
		this.loadConfigPms()
		this.loadGlobalConfig()
	}

	componentDidUpdate(prevProps, prevState) {
		const elems = document.querySelectorAll('select')
		M.FormSelect.init(elems)
		if (this.props.config_pms !== prevProps.config_pms)
			this.loadConfigPms(true)
	}

	loadConfigPms = (fromProps = false) => {
		if (fromProps === true)
			this.setState({ config_pms: this.props.config_pms })
		else if (!this.state.config_pms)
		{
			this.props.fetchConfigPms()
			.then(config_pms => {
				this.setState({ config_pms: config_pms })
			})
			.catch(err => {
				console.log(err)
			})
		}
	}

	loadGlobalConfig = () => {
		this.props.fetchDashboardConfig()
		.then(config => {
			console.log("global config: ", config)
			const billing = config.due_billing || {}
			const form1 = {
				...this.state.form1,
				active_connexion: config.active_connexion,
				show_stay_dates: config.show_stay_dates,
				show_stay_location: config.show_stay_location,
				application_ouverte: config.application_ouverte,
				bcc_inventories: (!config.config_emails.bcc_inventories) ? "" : config.config_emails.bcc_inventories,
				bcc_services: (!config.config_emails.bcc_services) ? "" : config.config_emails.bcc_services,
				default: (!config.config_emails.default) ? "" : config.config_emails.default,
				inventories: (!config.config_emails.inventories) ? "" : config.config_emails.inventories,
				services: (!config.config_emails.services) ? "" : config.config_emails.services,
				due_billing_unpaid: (billing.unpaid === true) ? 2 : (Number(billing.unpaid) || 0),
				due_billing_date: billing.due_date || "",
				due_billing_url: billing.url_bill || ""
			}
			this.setState({ form1: form1 })
		})
		.catch(err => {
			console.log(err)
		})
	}

	setErrorMsg = (key, msg) => {
		if (key === "default_update_config")
		{
			key = "global"
			msg = "Erreur: Impossible de mettre à jour les paramètres administrateurs. Veuillez contacter le service technique (code : #" + msg + ")"
		}
		let error = this._initErrors()
		error[key] = msg
		this.setState({ success: null, error: error })
	}

	setSuccessMsg = (msg) => {
		this.setState({ error: this._initErrors(), success: msg })
	}

	clearFlash = () => {
		this.setState({ error: this._initErrors(), success: null })
	}

	_initErrors = () => {
		const errors = {
			global: null,
			establishment: null,
			welcome: null,
			nbdays: null,
			langs: null
		}
		return errors
	}

	handleFeatures = (event) => {
		this.setState({ features: event.target.value })
	}

	handleDefaultEmail = (event) => {
		const form1 = {
			...this.state.form1,
			default: event.target.value
		}
		this.setState({ form1: form1 })
	}

	handleServicesEmail = (event) => {
		const form1 = {
			...this.state.form1,
			services: event.target.value
		}
		this.setState({ form1: form1 })
	}

	handleServicesEmailBcc = (event) => {
		const form1 = {
			...this.state.form1,
			bcc_services: event.target.value
		}
		this.setState({ form1: form1 })
	}

	handleInventoriesEmail = (event) => {
		const form1 = {
			...this.state.form1,
			inventories: event.target.value
		}
		this.setState({ form1: form1 })
	}

	handleInventoriesEmailBcc = (event) => {
		const form1 = {
			...this.state.form1,
			bcc_inventories: event.target.value
		}
		this.setState({ form1: form1 })
	}

	handleActiveConnexion = (event) => {
		const form1 = {
			...this.state.form1,
			active_connexion: (this.state.form1.active_connexion === true) ? false : true
		}
		this.setState({ form1: form1 })
	}

	handleShowStayDates = (event) => {
		const form1 = {
			...this.state.form1,
			show_stay_dates: (this.state.form1.show_stay_dates === true) ? false : true
		}
		this.setState({ form1: form1 })
	}

	handleShowStayLocation = (event) => {
		const form1 = {
			...this.state.form1,
			show_stay_location: (this.state.form1.show_stay_location === true) ? false : true
		}
		this.setState({ form1: form1 })
	}

	handleDueBillingUnpaid = (event) => {
		const form1 = {
			...this.state.form1,
			due_billing_unpaid: Number(event.target.value)
		}
		this.setState({ form1: form1 })
	}

	handleDueBillingDate = (event) => {
		const form1 = {
			...this.state.form1,
			due_billing_date: event.target.value
		}
		this.setState({ form1: form1 })
	}

	handleDueBillingUrl = (event) => {
		const form1 = {
			...this.state.form1,
			due_billing_url: event.target.value
		}
		this.setState({ form1: form1 })
	}

	handlePMS = (event) => {
		const name = event.target.value
		const values = {
			...this.state.config_pms.values,
			name: name
		}
		if (name === "inaxel" || name === "e-season" || name === "logmis")
		{
			values.period = "1030"
			values.separator = ';'
		}
		else if (name === "hippocamp")
			values.period = "0500"
		else if (name === "applicamp")
			values.period = "0600"
		const config_pms = {
			...this.state.config_pms,
			values: values
		}
		this.setState({ config_pms: config_pms })
	}

	handlePeriod = (event) => {
		const config_pms = {
			...this.state.config_pms,
			values: {
				...this.state.config_pms.values,
				period: event.target.value
			}
		}
		this.setState({ config_pms: config_pms })
	}

	handlePrefix = (event) => {
		const config_pms = {
			...this.state.config_pms,
			values: {
				...this.state.config_pms.values,
				prefix: event.target.value
			}
		}
		this.setState({ config_pms: config_pms })
	}

	handleFTPHost = (event) => {
		const config_pms = {
			...this.state.config_pms,
			values: {
				...this.state.config_pms.values,
				ftp_host: event.target.value
			}
		}
		this.setState({ config_pms: config_pms })
	}

	handleFTPUser = (event) => {
		const config_pms = {
			...this.state.config_pms,
			values: {
				...this.state.config_pms.values,
				ftp_user: event.target.value
			}
		}
		this.setState({ config_pms: config_pms })
	}

	handleFTPPassword = (event) => {
		const config_pms = {
			...this.state.config_pms,
			values: {
				...this.state.config_pms.values,
				ftp_pass: event.target.value
			}
		}
		this.setState({ config_pms: config_pms })
	}

	handleInternToken = (event) => {
		const config_pms = {
			...this.state.config_pms,
			values: {
				...this.state.config_pms.values,
				intern_token: event.target.value
			}
		}
		this.setState({ config_pms: config_pms })
	}

	handleAPIToken = (event) => {
		const config_pms = {
			...this.state.config_pms,
			values: {
				...this.state.config_pms.values,
				api_token: event.target.value
			}
		}
		this.setState({ config_pms: config_pms })
	}

	handleAPIURL = (event) => {
		const config_pms = {
			...this.state.config_pms,
			values: {
				...this.state.config_pms.values,
				api_url: event.target.value
			}
		}
		this.setState({ config_pms: config_pms })
	}

	handleLastHandling = (event) => {
		const value = event.target.value
		const config_pms = {
			...this.state.config_pms,
			values: {
				...this.state.config_pms.values,
				last_handling: (value === "") ? null : Number(value)
			}
		}
		this.setState({ config_pms: config_pms })
	}

	// _validateForm1 = () => {
	// 	let error_obj = this._initErrors()
	// 	let error = false
	// 	const establishment = this.state.form1.establishment
	// 	if (establishment.length === 0)
	// 	{
	// 		error = true
	// 		error_obj.establishment = "Veuillez renseigner le nom de l'établissement"
	// 	}
	// 	else if (establishment.length > this.length_max)
	// 	{
	// 		error = true
	// 		error_obj.establishment = "Le nom de l'établissement ne doit pas dépasser " + this.length_max + " caractères"
	// 	}
	// 	if (error === true)
	// 	{
	// 		error_obj.global = "Il y a une ou plusieurs erreur(s) dans le formulaire"
	// 		this.setState({ success: null, error: error_obj, attempt_submit: false })
	// 	}
	// 	return (!error) ? true : false
	// }

	// _updateConfig = () => {
	// 	const config = {
	// 		establishment: this.state.form1.establishment,
	// 		sendmail: this.state.form1.sendmail,
	// 		nbdays: this.state.form1.nbdays,
	// 		connexion: this.state.form1.connexion,
	// 		langs: {
	// 			fr: this.state.form1.fr,
	// 			en: this.state.form1.en,
	// 			de: this.state.form1.de,
	// 			nl: this.state.form1.nl,
	// 			it: this.state.form1.it,
	// 			es: this.state.form1.es,
	// 			pt: this.state.form1.pt
	// 		},
	// 		background: this.state.form1.background,
	// 		welcome: this.state.form1.welcome
	// 	}
	// 	this.props.updateConfig(config)
	// 	.then(ret => {
	// 		if (!ret)
	// 		{
	// 			this.setState({ attempt_submit: false })
	// 			this.setErrorMsg('default_update_config', 1)
	// 		}
	// 		else
	// 		{
	// 			this.setState({ attempt_submit: false })
	// 			this.setSuccessMsg('Les paramètres ont bien été mis à jour')
	// 		}
	// 	})
	// 	.catch(err => {
	// 		this.setState({ attempt_submit: false })
	// 		this.setErrorMsg('default_update_config', 2)
	// 		console.log(err)
	// 	})
	// }

	handleSubmit = (event) => {
		event.preventDefault()
		this.setState({ attempt_submit: true })
		const config = {
			config_pms: this.state.config_pms.values,
			features: this.state.features,
			active_connexion: this.state.form1.active_connexion,
			application_ouverte: this.state.form1.application_ouverte,
			show_stay_dates: this.state.form1.show_stay_dates,
			show_stay_location: this.state.form1.show_stay_location,
			config_emails: {
				bcc_services: this.state.form1.bcc_services,
				bcc_inventories: this.state.form1.bcc_inventories,
				default: this.state.form1.default,
				inventories: this.state.form1.inventories,
				services: this.state.form1.services
			},
			due_billing: {
				unpaid: this.state.form1.due_billing_unpaid,
				due_date: this.state.form1.due_billing_date || null,
				url_bill: this.state.form1.due_billing_url
			}
		}
		this.props.updateConfigDashboard(config)
		.then(ret => {
			if (!ret)
			{
				this.setState({ attempt_submit: false })
				this.setErrorMsg('default_update_config', 1)
			}
			else
			{
				this.setState({ attempt_submit: false })
				this.setSuccessMsg('Les paramètres ont bien été mis à jour')
			}
		})
		.catch(err => {
			this.setState({ attempt_submit: false })
			this.setErrorMsg('default_update_config', 2)
			console.log(err)
		})
	}

	answerModal = (answer) => {
		if (answer === "yes")
			this._updateConfig()
		else
			this.setState({ attempt_submit: false, open_modal: false })
	}

	updateLang = (lang) => {
		this.setState({ current_lang: lang })
	}

	render() {
		let sendbtn = (<button type="submit" className="waves-effect waves-light btn-small">Enregistrer</button>)
		const permissions = this.props.user.permissions
		if (!permissions || !permissions.super || permissions.super === 0)
			return (<Redirect to="/" />)
		else if (!this.state.config_pms)
		{
			return (
				<div className="center">
					<Loader />
				</div>
			)
		}
		else if (this.state.attempt_submit === true)
		{
			sendbtn = (
				<div className="center">
					<Loader />
				</div>
			)
		}
		let paramPrefix = null
		let paramFTPHost = null
		let paramFTPUser = null
		let paramFTPPassword = null
		let paramSeparator = null
		if (this.state.config_pms.values.name === "inaxel" || this.state.config_pms.values.name === "e-season" || this.state.config_pms.values.name === "logmis")
		{
			paramPrefix = (
				<label>
					<p className="column-30">Préfixe :</p>
					<input type="text" value={this.state.config_pms.values.prefix} onChange={this.handlePrefix} />
				</label>
			)
			paramFTPHost = (
				<label>
					<p className="column-30">Hôte FTP :</p>
					<input type="text" value={this.state.config_pms.values.ftp_host} onChange={this.handleFTPHost} />
				</label>
			)
			paramFTPUser = (
				<label>
					<p className="column-30">Utilisateur FTP :</p>
					<input type="text" value={this.state.config_pms.values.ftp_user} onChange={this.handleFTPUser} />
				</label>
			)
			paramFTPPassword = (
				<label>
					<p className="column-30">Mot de passe FTP :</p>
					<input type="text" value={this.state.config_pms.values.ftp_pass} onChange={this.handleFTPPassword} />
				</label>
			)
			paramSeparator = (
				<label>
					<p className="column-30">Séparateur :</p>
					<input type="text" value={this.state.config_pms.values.separator} disabled />
				</label>
			)
		}
		let paramInternToken = null
		if (this.state.config_pms.values.name === "applicamp")
		{
			paramInternToken = (
				<label>
					<p className="column-30">Token interne :</p>
					<input type="text" value={this.state.config_pms.values.intern_token} onChange={this.handleInternToken} />
				</label>
			)
		}
		let paramAPIToken = null
		let paramAPIURL = null
		if (this.state.config_pms.values.name === "hippocamp")
		{
			paramAPIToken = (
				<label>
					<p className="column-30">Token API :</p>
					<input type="text" value={this.state.config_pms.values.api_token} onChange={this.handleAPIToken} />
				</label>
			)
			paramAPIURL = (
				<label>
					<p className="column-30">URL API :</p>
					<input type="text" value={this.state.config_pms.values.api_url} onChange={this.handleAPIURL} />
				</label>
			)
		}
		const last_update = tools.parseDate(this.state.config_pms.values.last_handling, true)
		return (
			<div className="wrapper-content">
				<Modal
					dismissible={false}
					content={this.state.modal_msg}
					open_modal={this.state.open_modal}
					answerModal={this.answerModal}
				/>
				{/* Breadcrumb */}
				<div className="mb-5">
					<ol className="flex items-center gap-1 text-sm">
						<li className="flex items-center">
							<Link to="/" className="text-gray-400 hover:text-gray-600 transition-colors">
								<HomeIcon className="flex-shrink-0 h-4 w-4" aria-hidden="true" />
								<span className="sr-only">Accueil</span>
							</Link>
						</li>
						<li className="flex items-center">
							<span className="text-gray-300 mx-1 select-none">/</span>
							<Link to="/administration/parametres" className="text-gray-400 hover:text-gray-600 transition-colors">Paramètres</Link>
						</li>
						<li className="flex items-center">
							<span className="text-gray-300 mx-1 select-none">/</span>
							<span className="text-gray-400">Paramètres admin</span>
						</li>
					</ol>
				</div>
				{/* Page header */}
				<div className="flex items-end justify-between mb-8">
					<div>
						<h1
							style={{ fontFamily: "'Fraunces', Georgia, serif", letterSpacing: '-0.02em', margin: 0 }}
							className="text-4xl font-bold text-gray-900 leading-none"
						>
							Paramètres admin
						</h1>
						<p className="text-sm text-gray-400" style={{ margin: '0.5rem 0 0' }}>
							Fonctionnalités, formule et configuration avancée
						</p>
					</div>
				</div>
				{/* Onglets */}
				<div className="flex gap-1 border-b border-gray-200 mb-6">
					<button
						type="button"
						onClick={() => this.setState({ tab: 'config' })}
						className={`px-4 py-2.5 text-sm font-semibold border-b-2 -mb-px transition-colors ${this.state.tab === 'config' ? 'border-indigo-600 text-indigo-600' : 'border-transparent text-gray-400 hover:text-gray-600'}`}
					>
						Configuration
					</button>
					<button
						type="button"
						onClick={() => this.setState({ tab: 'payments' })}
						className={`px-4 py-2.5 text-sm font-semibold border-b-2 -mb-px transition-colors ${this.state.tab === 'payments' ? 'border-indigo-600 text-indigo-600' : 'border-transparent text-gray-400 hover:text-gray-600'}`}
					>
						Paiements CB
					</button>
				</div>
				{this.state.tab === 'payments' ? (
					<StripePayments fetchStripePayments={this.props.fetchStripePayments} />
				) : (
				<form className="module-form" onSubmit={this.handleSubmit}>
					<div className="row">
						<div className="module col s6">
							{sendbtn}
						</div>
						<div className="module col s6">
							<p>
								Dernière mise à jour de la passerelle : <strong>{last_update}</strong>
							</p>
						</div>
					</div>
					<div className="row">
						<div className="module col s6">
							<h2 className="title-description">Paramètres généraux</h2>
							<p className="success">{this.state.success}</p>
							<label>
								<p className="column-20">Formule :</p>
								<select value={this.state.features} onChange={this.handleFeatures}>
									<option value="">-- Sélectionez un Pack --</option>
									<option value="essentiel">Essentiel</option>
									<option value="premium">Premium</option>
								</select>
							</label>
							<label>

								{/* <p className="error">{this.state.error.establishment}</p> */}
								<p className="column-30">E-mail par défaut :</p>
								<input type="text" value={this.state.form1.default} onChange={this.handleDefaultEmail} />
							</label>
							<label>
								<p className="column-30">E-mail inventaires :</p>
								<input type="text" value={this.state.form1.inventories} onChange={this.handleInventoriesEmail} />
							</label>
							<label>
								<p className="column-30">E-mail inventaires (bcc) :</p>
								<input type="text" value={this.state.form1.bcc_inventories} onChange={this.handleInventoriesEmailBcc} />
							</label>
							<label>
								<p className="column-30">E-mail services :</p>
								<input type="text" value={this.state.form1.services} onChange={this.handleServicesEmail} />
							</label>
							<label>
								<p className="column-30">E-mail services (bcc) :</p>
								<input type="text" value={this.state.form1.bcc_services} onChange={this.handleServicesEmailBcc} />
							</label>
							<label>
								<p className="column-30">Activer la connexion sur la webapp :</p>
								<input type="checkbox" checked={this.state.form1.active_connexion} onChange={this.handleActiveConnexion} />
								<span></span>
							</label>
							<label>
								<p className="column-30">Afficher le n° d'emplacement sur "Mon Compte" :</p>
								<input type="checkbox" checked={this.state.form1.show_stay_location} onChange={this.handleShowStayLocation} />
								<span></span>
							</label>
							<label>
								<p className="column-30">Afficher les dates de séjours sur "Mon Compte" :</p>
								<input type="checkbox" checked={this.state.form1.show_stay_dates} onChange={this.handleShowStayDates} />
								<span></span>
							</label>
							<label>
								<p className="column-30">Bandeau facture impayée :</p>
								<select value={this.state.form1.due_billing_unpaid} onChange={this.handleDueBillingUnpaid}>
									<option value={0}>Désactivé</option>
									<option value={1}>Niveau 1</option>
									<option value={2}>Niveau 2</option>
								</select>
							</label>
							<label>
								<p className="column-30">Date limite de paiement :</p>
								<input type="date" value={this.state.form1.due_billing_date} onChange={this.handleDueBillingDate} />
							</label>
							<label>
								<p className="column-30">URL Facture :</p>
								<input type="text" value={this.state.form1.due_billing_url} onChange={this.handleDueBillingUrl} />
							</label>
						</div>
						<div className="module col s6">
							<h2 className="title-description">Paramètres passerelle</h2>
							<label>
								<p className="column-20">PMS :</p>
								<select value={this.state.config_pms.values.name} onChange={this.handlePMS}>
									<option value="">-- Sélectionez un PMS --</option>
									<option value="inaxel">Inaxel</option>
									<option value="e-season">E-Season</option>
									<option value="hippocamp">Hippocamp</option>
									<option value="applicamp">Applicamp</option>
									<option value="logmis">Logmis</option>
									<option value="koban">Koban</option>
								</select>
							</label>
							<label>
								<p className="column-30">Période :</p>
								<input type="text" value={this.state.config_pms.values.period} onChange={this.handlePeriod} />
							</label>
							<label>
								<p className="column-30">Dernier traitement (timestamp) :</p>
								<input type="number" value={(this.state.config_pms.values.last_handling != null) ? this.state.config_pms.values.last_handling : ""} onChange={this.handleLastHandling} />
							</label>
							{paramPrefix}
							{paramFTPHost}
							{paramFTPUser}
							{paramFTPPassword}
							{paramSeparator}
							{paramInternToken}
							{paramAPIToken}
							{paramAPIURL}
							<p className="error">{this.state.error.global}</p>
						</div>
					</div>
				</form>
				)}
			</div>
		)
	}
}

export default ConfigAdmin
